import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-4" }, null, -1)
const _hoisted_3 = { class: "p-col-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Steps, {
          model: $setup.items,
          readonly: true
        }, null, 8, ["model"])
      ]),
      _hoisted_4
    ]),
    _createVNode(_component_router_view, {
      onPrevPage: _cache[0] || (_cache[0] = ($event: any) => ($setup.prevPage($event))),
      onNextPage: _cache[1] || (_cache[1] = ($event: any) => ($setup.nextPage($event))),
      onComplete: $setup.complete,
      formData: $setup.formObject
    }, {
      default: _withCtx(({Component}) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    }, 8, ["onComplete", "formData"])
  ]))
}